<template>
  <!-- 房屋管理 -->
  <div class="HousingManagement">
    <el-form class="select" label-width="100px">
      <el-form-item label="入住老师:">
        <el-select class="select" filterable clearable v-model="fromState.teacherId" placeholder="请选择老师名称" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
              :label="teacher.realname" :value="teacher.id">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="缴费状态:">
        <el-select class="select" filterable clearable v-model="fromState.paymentStatus" placeholder="请选择缴费状态" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in paymentStatusList" :key="teacher.value"
              :label="teacher.text" :value="teacher.value">
        </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属地域:">
        <el-select class="select" filterable clearable v-model="fromState.regionalAffiliation" placeholder="请选择所属地域" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in thisRegion" :key="teacher.dictType"
              :label="teacher.dictValue" :value="teacher.dictType">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="clear" class="btns" size="small" icon="el-icon-close">清除</el-button>
        <el-button type="primary" @click="searchBtn"  size="small" class="btns" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="addRoom('add')"  size="small" class="btns" icon="el-icon-plus">添加</el-button>
      </el-form-item>
    </el-form>
    <!-- table表格 -->
    <el-table :header-cell-style="{
      background: '#fafafa',
    }" :data="dataList" border>
      <!-- <el-table-column prop="teacherName" label="租住教师">
      </el-table-column> -->
      <el-table-column prop="roomNo" label="房间号" width="80">
      </el-table-column>
      <el-table-column prop="checkInGender" label="性别" >
        <template slot-scope="scope">
          <p>{{ scope.row.checkInGender === 1? '男' : '女' }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="occupancy" label="入住人数" >
      </el-table-column>
      <el-table-column prop="limitPeople" label="最多入住人数" >
      </el-table-column>
      <el-table-column prop="regionalAffiliationName" label="所属地域">
      </el-table-column>
      <el-table-column prop="rentalTime" label="房屋租赁时间">
      </el-table-column>
      <el-table-column prop="expirationTime" label="房屋到期时间">
      </el-table-column>
      <el-table-column prop="deposit" label="押金">
      </el-table-column>
      <el-table-column prop="rent" label="租金">
      </el-table-column>
      <el-table-column prop="contactPerson" label="对接人">
      </el-table-column>
      <el-table-column prop="contactPersonTelephone" width="130" label="对接人联系方式">
      </el-table-column>
      <el-table-column prop="paymentStatus" label="缴费状态">
        <template slot-scope="scope">
          <p>{{ scope.row.paymentStatus === true? '已交齐' : '未交齐' }}</p>
        </template>
      </el-table-column>
      <el-table-column header-align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="addRoom('edit',scope.row)">编辑</el-button>
          <el-button type="text" @click="details(scope.row.id)">入住信息</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="fromState.pageNo" :page-size="fromState.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="total">
    </el-pagination>

    <!-- 添加房屋信息 -->
    <el-dialog :title="isFlog ? '房屋编辑' : '添加房屋信息'" :visible.sync="isShow" :close-on-click-modal = false>
      <el-form label-width="120px">
        <el-form-item label="房间号:" style="width: 100%; text-align: left;">
          <el-input v-model="addObj1.roomNo" placeholder="请输入房间号" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item label="性别:" style="width: 100%; text-align: left;">
          <!-- <el-input v-model="addObj1.checkInGender" placeholder="请输入房间号" autocomplete="off" ></el-input> -->
            <el-radio-group v-model="addObj1.checkInGender">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="最多入住人数:" style="width: 100%; text-align: left;">
          <el-input v-model="addObj1.limitPeople" placeholder="请输入最多入住人数" autocomplete="off" ></el-input>
        </el-form-item>
        <el-form-item label="签约公司:" style="width: 100%; text-align: left;">
          <el-select class="select" filterable clearable v-model="addObj1.signingCompany" placeholder="请选择签约公司" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in thisCompany" :key="teacher.dictType"
              :label="teacher.dictValue" :value="teacher.dictType">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="所属地域:" style="width: 100%; text-align: left;">
        <el-select class="select" filterable clearable v-model="addObj1.regionalAffiliation" placeholder="请选择所属地域" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in thisRegion" :key="teacher.dictType"
              :label="teacher.dictValue" :value="teacher.dictType">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="房屋所在地:" style="width: 100%; text-align: left;">
          <el-input v-model="addObj1.housesLocation" placeholder="请输入房屋所在地" autocomplete="off"
            @keyup.enter.native="changeRoom"></el-input>
        </el-form-item>
        <el-form-item label="房屋租赁时间:" style="width: 100%; text-align: left;">
          <el-date-picker v-model="addObj1.rentalTime" style="width: 100%;" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="房屋到期时间:" style="width: 100%; text-align: left;">
          <el-date-picker v-model="addObj1.expirationTime" style="width: 100%;" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="押金:" style="width: 100%; text-align: left;">
          <el-input v-model="addObj1.deposit" placeholder="请输入押金" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="租金:" style="width: 100%; text-align: left;">
          <el-input v-model="addObj1.rent" placeholder="请输入租金" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="对接人:" style="width: 100%; text-align: left;">
          <el-input v-model="addObj1.contactPerson" placeholder="请输入对接人" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="对接人联系方式:" style="width: 100%; text-align: left;">
          <el-input v-model="addObj1.contactPersonTelephone" placeholder="请输入对接人联系方式" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancellation">取 消</el-button>
        <el-button type="primary" @click="addsRoomInfo">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 入住信息 -->
    <el-dialog title="入住信息详情" :visible.sync="isShowDetails">

    <el-form class="select" label-width="120px">
      <el-form-item label="老师姓名:">
        <!-- <el-input placeholder="请输入老师姓名" v-model="roomDataList.teacherId" clearable></el-input> -->
        <el-select class="select" filterable clearable v-model="guestsData.teacherId" placeholder="请选择老师名称" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
              :label="teacher.realname" :value="teacher.id">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入住状态:">
        <!-- <el-input placeholder="请选择入住状态" v-model="roomDataList.stayingStatus" clearable></el-input> -->
          <el-select class="select" filterable clearable v-model="guestsData.stayingStatus" placeholder="请选择老师名称" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in roomStatus" :key="teacher.value"
              :label="teacher.text" :value="teacher.value">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入住时间:">
        <!-- <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="roomDataList.stayingStartTime"> -->
          <el-date-picker v-model="roomTimer" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        <!-- </el-date-picker> -->
      </el-form-item>
      <el-form-item label="搬离时间:">
        <!-- <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="roomDataList.movingOutStartTime" placeholder="选择日期">
        </el-date-picker> -->
        <el-date-picker v-model="outRoomTimer" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="clearRoom" class="btns" size="small" icon="el-icon-close">清除</el-button>
        <el-button type="primary" @click="searchBtnRoom"  size="small" class="btns" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="addteacher"  size="small" class="btns" icon="el-icon-plus">添加入住教师</el-button>
      </el-form-item>
    </el-form>
    <!-- table表格 -->
    <el-table :header-cell-style="{
      background: '#fafafa',
    }" :data="guestsDataList" border>
      <el-table-column prop="teacherName" label="入住老师" width="80">
      </el-table-column>
      <el-table-column prop="checkInTime" label="入住时间">
      </el-table-column>
      <el-table-column prop="monthlyRent" label="月租金">
      </el-table-column>
      <el-table-column prop="thisMonthlyRent" label="当月租金">
      </el-table-column>
      <el-table-column prop="movingOutTime" label="搬离时间">
      </el-table-column>
      <el-table-column prop="stayingStatus" label="入住状态">
        <template slot-scope="scope">
          <p>{{ scope.row.stayingStatus === 1? '已搬离' : '在住' }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="paymentStatus" label="缴费状态">
        <template slot-scope="scope">
          <p>{{ scope.row.paymentStatus === 1? '已缴纳' : '未缴纳' }}</p>
        </template>
      </el-table-column>
      <el-table-column header-align="center" width="100" label="租金详情">
        <template slot-scope="scope">
          <el-button type="text" @click="handleRent(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column header-align="center" width="100" label="操作">
        <template slot-scope="scope">
          <p v-if="scope.row.stayingStatus === 1">已搬离</p>
          <el-button type="text" @click="handleMovingOut(scope.row)" v-else>搬离</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="handleSizeChangeguestsData" @current-change="handleCurrentChangeguestsData"
      :current-page="guestsData.pageNo" :page-size="guestsData.pageSize"
      layout="prev, pager, next,sizes, jumper" :total="guestsData.total">
    </el-pagination>
    </el-dialog>
<!-- 添加入住老师，搬离 -->
    <el-dialog :title="isFlage ? '添加入住老师': '搬离操作' " :visible.sync="isShowTeacher">
      <el-form label-width="120px">
        <el-form-item label="入住老师:" style="width: 100%; text-align: left;" v-if="isFlage">
        <el-select class="select" filterable clearable v-model="addObj.teacherId" placeholder="请选择老师名称" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in teachers" :key="teacher.id"
              :label="teacher.realname" :value="teacher.id">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="入住时间:" style="width: 100%; text-align: left;" v-if="isFlage">
          <el-date-picker v-model="addObj.checkInTime" style="width: 100%;" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月租金:" style="width: 100%; text-align: left;" v-if="isFlage">
          <el-input v-model="addObj.monthlyRent" placeholder="请输入月租金" autocomplete="off"
            @keyup.enter.native="changeRoom"></el-input>
        </el-form-item>
      <div v-else>
        <el-form-item label="搬离时间:" style="width: 100%; text-align: left;" >
          <el-date-picker v-model="addObj.movingOutTime" style="width: 100%;" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择日期" @change="changeOutRoomStatus">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="待缴费用:" style="width: 100%; text-align: left;" >
          <el-input v-model="addObj.paymentFee" placeholder="请输入代缴费用" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="缴费状态:" style="width: 100%; text-align: left;" >
          <!-- <el-input v-model="addObj.paymentStatus" placeholder="请输入租金" autocomplete="off"></el-input> -->
          <el-select class="select" filterable clearable v-model="addObj.paymentStatus" placeholder="请选择缴费状态" style="width:100%;">
            <el-option style="margin-left: 10px" v-for="teacher in paymentStatusList1" :key="teacher.value"
              :label="teacher.text" :value="teacher.value">
            </el-option>
        </el-select>
        </el-form-item>
      </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowTeacherFalse">取 消</el-button>
        <el-button type="primary" @click="addsRoomInfoList">确 定</el-button>
      </div>
    </el-dialog>
      <!-- 入住详情 -->
    <el-dialog title="租金详情" :visible.sync="isShowRentDetails">
      <el-form class="select" label-width="120px">
      <!-- <el-form-item label="入住老师:">
        <el-input placeholder="请输入老师姓名" v-model="roomNumber" clearable></el-input>
      </el-form-item> -->
      <el-form-item label="月份:">
        <el-date-picker value-format="yyyy-MM" type="month" placeholder="选择月份" v-model="RentalDetaiTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="clearRentalDetaiTime" class="btns" size="small" icon="el-icon-close">清除</el-button>
        <el-button type="primary" @click="searchBtnRentalDetaiTime"  size="small" class="btns" icon="el-icon-search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- table表格 -->
    <el-table :header-cell-style="{
      background: '#fafafa',
    }" :data="RentalDetailsList" border>
      <el-table-column prop="teacherName" label="入住老师">
      </el-table-column>
      <el-table-column prop="yearMon" label="月份">
      </el-table-column>
      <el-table-column prop="rentToBePaid" label="待交费用">
      </el-table-column>
      <el-table-column prop="paymentStatus" label="缴费状态">
        <!-- <template slot-scope="scope">
          <p @click="handlePayFee(scope.row)" style="color: blue;">{{ scope.row.paymentStatus === 0? '未缴纳' : '已缴纳' }}</p>
        </template> -->
        <template slot-scope="scope">
              <el-radio-group v-model="scope.row.paymentStatus" @change="handlePayFee(scope.row)">
                <el-radio :label="0">未缴纳</el-radio>
                <el-radio :label="1">已缴纳</el-radio>
              </el-radio-group>
        </template>
      </el-table-column>
    </el-table>

    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import { el } from "@fullcalendar/core/internal-common";
export default {
  data () {
    return {
      isShowRentDetails:false,
      isFlage:true,
      isShowTeacher:false,
      isShowDetails:false,
      isShow: false,
      isFlog: true,
      dialogFormVisible: false,
      total: 0,
      contactPerson: "",//对接人
      deposit: "",//押金
      rent: '',//租金
      roomEndTime: "",//房屋到期时间
      roomNumber: "",//房间号
      roomStartTime: "",//房屋租赁时间teacherInTime
      teacherInTime: "",//入住时间
      teacherName: "",//教师姓名
      dataList: [],
      fromState: {
        teacherId: '',
        paymentStatus: '',
        pageSize: 10,
        pageNo: 1,
        regionalAffiliation:'',
      },
      paymentStatusList: [
        {text:'已交齐',value:true},
        {text:'未交齐',value:false},
      ],
      paymentStatusList1: [
        {text:'已交齐',value:1},
        {text:'未交齐',value:0},
      ],
      addObj: {
        teacherId: '',
        checkInTime: '',
        monthlyRent: '',

        movingOutTime: '',
        paymentFee:0,
        paymentStatus:0,
      },
      addObj1: {
        id:'',
        roomNo: '',
        checkInGender:'',
        limitPeople:'',
        regionalAffiliation: null,
        housesLocation:'',
        signingCompany:null,
        contactPerson: "",//对接人
        deposit: "",//押金
        rent: '',//租金
        expirationTime: "",//房屋到期时间
        rentalTime: "",//房屋租赁时间
        contactPersonTelephone: "",//对接人联系方式
      },
      regionalAffiliationList: [
        { text:"北京",value:1},
        { text:"深圳",value:2},
      ],
      guestsData: {
        pageNo: 1,
        pageSize: 10,
        stayingStatus: '',
        teacherId: '',
        // stayingStartTime: '',
        // stayingEndTime: '',
        // movingOutStartTime: '',
        // movingOutEndTime: '',
        total:0
      },
      roomTimer: [],
      outRoomTimer:[],
      guestsDataList: [
        {teacherName:'kaixin'},
        {teacherName:'kaixin'},
        {teacherName:'kaixin'},
      ],
      teachers: [],
      thisRegion: [],
      thisCompany: [
        {dictValue:'测试公司',dictType:1}
      ],
      detailsid:'',
      roomDataList: {
        pageNo: 1,
        pageSize:10,
        teacherId: '',
        stayingStatus: '',
        roomTimer: [],
        outRoomTimer:[],

      },
      RentalDetailsList: [],
      RentalDetaiTime:'',
      RentalDetaiTeacherId: '',
      roomStatus: [
        {text:'在住', value:0},
        {text:'已搬离', value:1},
      ],
      outRomTeacherId:''
    }
  },
  created () {
    this.getList()

    axios.get(`${apiBaseUrl}/teacher/teacherList`, {
      headers: {
        'authorization': sessionStorage.getItem('tokenInfo')
      }
    }) // 请替换为你的API URL
      .then(response => {
        this.teachers = [...response.data.data]


      }).catch(error => {
        console.error(error);
      });

      axios.get(`${apiBaseUrl}/dict/getDictionary/${'地域'}`, {
      headers: {
        'authorization': sessionStorage.getItem('tokenInfo')
      }
    }) // 请替换为你的API URL
      .then(response => {
        this.thisRegion = [...response.data.data]


      }).catch(error => {
        console.error(error);
      });

      axios.get(`${apiBaseUrl}/dict/getDictionary/${'公司'}`, {
      headers: {
        'authorization': sessionStorage.getItem('tokenInfo')
      }
    }) // 请替换为你的API URL
      .then(response => {
        this.thisCompany = [...response.data.data]


      }).catch(error => {
        console.error(error);
      });
  },
  methods: {
    cancellation () {
      this.isShow = false
      this.addObj1={
        roomNo: '',
        checkInGender:'',
        regionalAffiliation: '',
        housesLocation:'',
        signingCompanyId:'',
        contactPerson: "",
        deposit: "",
        rent: '',
        expirationTime: "",
        rentalTime: "",
        contactPersonTelephone: "",
      },
      this.getList()
    },
    //添加房屋信息
    addsRoomInfo() {
      if (this.addObj1.id) {
        let data = {
        id:this.addObj1.id,
        roomNo: this.addObj1.roomNo,
        checkInGender:this.addObj1.checkInGender,
        limitPeople:this.addObj1.limitPeople,
        regionalAffiliation: this.addObj1.regionalAffiliation,
        housesLocation: this.addObj1.housesLocation,
        signingCompany: this.addObj1.signingCompany,
        contactPerson: this.addObj1.contactPerson,
        deposit: this.addObj1.deposit,
        rent: this.addObj1.rent,
        expirationTime: this.addObj1.expirationTime,
        rentalTime: this.addObj1.rentalTime,
        contactPersonTelephone: this.addObj1.contactPersonTelephone,
      }
          axios.put(`${apiBaseUrl}/houses/editHouses`, data, {
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
      })
        .then(res => {

          if (res.data.code === 200) {
            this.getList()
            this.$message({type: 'success', message: '修改成功'})
          } else {
            this.$message({ message: res.data.message,   type: "error"})
          }
        })
        .catch(error => {
          console.error(error);
        });
      } else {
        let obj = {
        roomNo: this.addObj1.roomNo,
        checkInGender:this.addObj1.checkInGender,
        limitPeople:this.addObj1.limitPeople,
        regionalAffiliation: this.addObj1.regionalAffiliation,
        housesLocation: this.addObj1.housesLocation,
        signingCompany: this.addObj1.signingCompany,
        contactPerson: this.addObj1.contactPerson,
        deposit: this.addObj1.deposit,
        rent: this.addObj1.rent,
        expirationTime: this.addObj1.expirationTime,
        rentalTime: this.addObj1.rentalTime,
        contactPersonTelephone: this.addObj1.contactPersonTelephone,
      }
      axios
        .post(`${apiBaseUrl}/houses/leaseOfHouses`, obj,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {

          if (res.data.code === 200) {
            this.getList()
            this.$message({type: 'success', message: '添加成功'})
          } else {
            this.$message({ message: res.data.message,   type: "error"})
          }
        })
        .catch(error => {
          console.error(error);
        });

      }



      this.getList()
      this.isShow = false
    },

    addsRoomInfoList() {


      if (this.isFlage) {
        let data = {
        roomId:this.detailsid,
        teacherId:this.addObj.teacherId,
        checkInTime:this.addObj.checkInTime,
        monthlyRent:this.addObj.monthlyRent
        }
        axios.post(`${apiBaseUrl}/staying/teacherStaying`, data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
        }).then((res) => {

        if (res.data.code === 200) {
          this.$message({ type: 'success', message: '添加成功' })

        } else {
            this.$message({ message: res.data.message,   type: "error"})
          }
          this.addObj = {
            teacherId: '',
            checkInTime: '',
            monthlyRent: '',

            movingOutTime: '',
            paymentFee:0,
            paymentStatus:0,
          },
        this.details(this.detailsid)
        this.isShowTeacher = false
        }).catch((error) => {
          console.error(error);
        })
      } else {
        let data = {
          stayingStatus:1,
          roomId: this.detailsid,
          teacherId:this.outRomTeacherId,
          movingOutTime:this.addObj.movingOutTime,
          paymentStatus:this.addObj.paymentStatus,
        }

        axios.put(`${apiBaseUrl}/staying/movingOut`, data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res) => {

        if (res.data.code === 200) {
          this.$message({type: 'success', message: '操作成功！'})
        } else {
            this.$message({ message: res.data.message,   type: "error"})
        }
        this.addObj = {
          teacherId: '',
          checkInTime: '',
          monthlyRent: '',

          movingOutTime: '',
          paymentFee:0,
          paymentStatus:0,
        },
        this.details(this.detailsid)
        this.isShowTeacher = false
        }).catch((error) => {
          console.error(error);
        })

      }
    },

    //添加按钮
    addRoom(tepy, row) {

      if (tepy === 'edit') {
        // signingCompany
        this.isFlog = true
        this.isShow = true
        this.addObj1.id = row.id
        this.addObj1.checkInGender = row.checkInGender
        this.addObj1.limitPeople = row.limitPeople
        this.addObj1.roomNo = row.roomNo
        this.addObj1.regionalAffiliation = row.regionalAffiliation
        this.addObj1.housesLocation = row.housesLocation
        this.addObj1.signingCompany = row.signingCompany
        this.addObj1.contactPerson = row.contactPerson
        this.addObj1.deposit = row.deposit
        this.addObj1.rent = row.rent
        this.addObj1.expirationTime = row.expirationTime
        this.addObj1.rentalTime = row.rentalTime
        this.addObj1.contactPersonTelephone = row.contactPersonTelephone
      } else {
        this.isFlog = false
        this.isShow = true
        this.addObj1={
          roomNo: '',
          limitPeople: '',
          checkInGender:'',
          regionalAffiliation: '',
          housesLocation:'',
          signingCompany:'',
          contactPerson: "",
          deposit: "",
          rent: '',
          expirationTime: "",
          rentalTime: "",
          contactPersonTelephone: "",
        }
      }
    },
    //根据房间号查询
    changeRoom () {
      let data = {
        roomNumber: this.addObj.roomNumber
      }
      axios
        .post(`${apiBaseUrl}/room/list`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then((res) => {
          if (res.data.data.list.length > 0) {
            this.addObj1.roomStartTime = res.data.data.list[0].roomStartTime
            this.addObj1.roomEndTime = res.data.data.list[0].roomEndTime
            this.addObj1.deposit = res.data.data.list[0].deposit
            this.addObj1.rent = res.data.data.list[0].rent
            this.addObj1.contactPerson = res.data.data.list[0].contactPerson
            this.addObj1.contactPersonPhone = res.data.data.list[0].contactPersonPhone
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleSizeChange (pageSize) {
      this.fromState.pageSize = pageSize;
      this.getList();
    },
    handleSizeChangeguestsData(size) {
      this.guestsData.pageSize = size;
      this.details(this.detailsid)
    },
    // 进入某一页
    handleCurrentChange (newPage) {
      this.fromState.pageNo = newPage;
      this.getList();
    },
    handleCurrentChangeguestsData(size) {
      this.guestsData.pageNo = size;
      this.details(this.detailsid)
    },
    //获取表格数据
    getList () {
      let data = {
        pageNo: this.fromState.pageNo,
        pageSize: this.fromState.pageSize,
        teacherId: this.fromState.teacherId,
        paymentStatus: this.fromState.paymentStatus,
        regionName:this.fromState.regionalAffiliation ||  localStorage.getItem('cityTepy'),
      }
      axios.post(`${apiBaseUrl}/houses/getHousesList`, data,{
      // axios.post(`${apiBaseUrl}/room/page`, data,{
        headers:{
        'authorization': sessionStorage.getItem('tokenInfo')
        }
      }).then((res) => {
        if (res.data.code === 200) {
            this.total = res.data.data.allTotal
            this.dataList = res.data.data.list
        } else {
            this.$message({ message: res.data.msg,   type: "error"})
        }
        }).catch((error) => {
          console.error(error);
        })
    },
    //编辑
    houseEdit (row) {

      this.isFlog = true
      this.dialogFormVisible = true
    },

    clear() {
      this.fromState.teacherId = ''
      this.fromState.regionName = ''
      this.fromState.paymentStatus = ''
      this.fromState.regionalAffiliation = ''
      this.getList()
    },
    //详情
    details(id) {
      this.detailsid = id
      this.isShowDetails = true
      // this.isFlog = false,
      // this.dialogFormVisible = true
      let data = {
        roomId:id,
        pageNo: this.guestsData.pageNo,
        pageSize: this.guestsData.pageSize,
        stayingStatus: this.guestsData.stayingStatus,
        teacherId: this.guestsData.teacherId,
        stayingStartTime: this.roomTimer[0],
        stayingEndTime: this.roomTimer[1],
        movingOutStartTime: this.outRoomTimer[0],
        movingOutEndTime:this.outRoomTimer[1],
        }

      axios.post(`${apiBaseUrl}/staying/getGuestsStaying` , data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {

          this.guestsDataList = res.data.data.records
          this.guestsData.total = res.data.data.total
        })
        .catch(error => {
          console.error(error);
        });
    },
    addteacher(){
      this.isFlage = true
      this.isShowTeacher = true
    },
    handleMovingOut(row){
      this.outRomTeacherId = row.teacherId
      this.isShowTeacher = true
      this.isFlage = false
    },
    changeOutRoomStatus() {
      let data = {
        movingOutTime: this.addObj.movingOutTime,
        teacherId:this.outRomTeacherId
      }

      axios.post(`${apiBaseUrl}/staying/countCost`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {

          if (res.data === null) {
            this.addObj.paymentFee = 0
          } else {
            this.addObj.paymentFee = res.data.data
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    handleRent(row) {
      this.RentalDetaiTeacherId = row.teacherId
      this.isShowRentDetails = true
      this.getRentalDetaiList()
    },
    getRentalDetaiList() {
        let data = {
        teacherId: this.RentalDetaiTeacherId,
        pageNo: 1,
        pageSize: 10,
        yearMonth:this.RentalDetaiTime
      }

      axios.post(`${apiBaseUrl}/payment/getPaymentRentRecord` , data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(res => {

          this.RentalDetailsList = res.data.data.records
        })
        .catch(error => {
          console.error(error);
        });
    },
    clearRentalDetaiTime() {
      this.RentalDetaiTime = ''
      this.getRentalDetaiList()
    },
    searchBtnRentalDetaiTime() {
      this.getRentalDetaiList()
    },
    //搜索
    searchBtn() {

      this.fromState.pageNo = 1
      this.getList()
    },
    clearRoom() {
      this.guestsData={
        teacherId: '',
        stayingStatus: '',
        pageNo: 1,
        pageSize: 10,
      }
      this.roomTimer = [],
      this.outRoomTimer = []
      this.details(this.detailsid)
    },
    searchBtnRoom() {
      this.guestsData.pageNo = 1
      this.details(this.detailsid)

    },
    handlePayFee(row) {

      // if () {
      //   this.$message({ message: '已交房租不可操作',   type: "error"})
      // } else {
        let data = {
            paymentStatus: row.paymentStatus,
            id:row.id
          }

        axios.put(`${apiBaseUrl}/payment/updatePaymentStatus` , data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
          .then(res => {

            if (res.data.code === 200) {
              this.$message({ type: 'success', message: res.data.message })
            } else {
              this.$message({ message: res.data.message,   type: "error"})

            }
            this.isShowRentDetails = false
            this.details(this.detailsid)
            this.getRentalDetaiList()


          })
          .catch(error => {
            console.error(error);
          });
      // }
    },
    isShowTeacherFalse() {
      this.addObj = {
        teacherId: '',
        checkInTime: '',
        monthlyRent: '',

        movingOutTime: '',
        paymentFee:0,
        paymentStatus:0,
      },
      this.isShowTeacher = false
    }
  }
}
</script>

<style scope>
.select {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 750px) {
  .HousingManagement {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.HousingManagement {
    width: 70% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/HousingManagement.vue